import { useMutation, useQueryClient } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { Topic } from '@pepper/utils/src/types/seo'

type Parameters = {
  companyId: string
  topicId: string
  topic?: string
  primaryKeyword?: string
  secondaryKeywords?: string[]
  createCrr?: boolean
  itemId?: string
  itemType?: 'assignment' | 'private_doc'
}

const handleEditProjectTopic = async ({
  companyId,
  topicId,
  topic,
  primaryKeyword,
  secondaryKeywords,
  createCrr = false,
  itemId,
  itemType
}: Parameters): Promise<{
  status: 'success' | 'error'
  error?: string
  records?: Topic
  message?: string
}> => {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/topics/${topicId}`
  const response = await axios.patch(url, {
    topic,
    primary_keyword: primaryKeyword,
    secondary_keywords: secondaryKeywords,
    create_crr: createCrr,
    item_id: itemId,
    item_type: itemType
  })
  return response.data
}

export const useEditProjectTopic = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: Parameters) => handleEditProjectTopic(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['project-topics'])
      queryClient.invalidateQueries(['research-report'])
    }
  })
}
